import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  OnChanges,
  OnInit,
  ViewChild
} from '@angular/core';
import { WidgetService } from '../../widget.service';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { RegionAttachable, WidgetMap, WidgetMapRegion, WidgetMapType } from '../../../models/widget';
import { MapEditorInstance } from './map-editor.instance';
import { ObjectService } from '../../../shared/object.service';
import { WidgetMapService } from '../../widget-map.service';
import { WidgetDetailInstanceService } from '../widget-detail-instance.service';
import 'rxjs/add/operator/switchMap';
import { CreateMapModalComponent } from '../create-map-modal/create-map-modal.component';
import { PObject } from '../../../models/object';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ModalService } from '../../../core/modal.service';
import { RegionAndEntity } from './editor-object-list/editor-object-list-item/editor-object-list-item.component';


let SVG = require('svg.js');
let SVGDraggable = require('svg.draggable.js');

class RegionPoint {
  selected: boolean;
  x: number;
  y: number;

  constructor(x: number, y: number) {
    this.x = x;
    this.y = y;
  }
}


@Component({
  selector: 'app-map-editor',
  templateUrl: './map-editor.component.html',
  providers: [MapEditorInstance]
})

export class MapEditorComponent implements OnInit, OnChanges, AfterViewInit {
  widgetIsLoaded: boolean;
  @ViewChild('main') mainCanvas: ElementRef;
  svg: any;

  zoomLevel: number = 1;
  //map: WidgetMap;

  private widgetId: number;
  private mapId: number;

  isSaving: boolean = false;
  _dirty: boolean = false;

  selectedRegion: WidgetMapRegion;
  projectObjects: PObject[];
  projectMaps: WidgetMap[];
  autoSizeOn: boolean = true;

  private loadingP: Promise<any>;
  private containerWidth: number;
  private containerHeight: number;
  private renderWhenReady: boolean;
  form: FormGroup;
  private saveTimer: any;
  regionEntityCtrl: FormControl;

  constructor(private mapEditor: MapEditorInstance,
              private cd: ChangeDetectorRef,
              private modal: ModalService,
              private fb: FormBuilder,
              private widgetInstance: WidgetDetailInstanceService,
              public instance: MapEditorInstance,
              private objectService: ObjectService,
              private widgetService: WidgetService,
              private mapService: WidgetMapService,
              private route: ActivatedRoute) {

    this.regionEntityCtrl = this.fb.control('', null);

    this.widgetInstance.$widget.subscribe(widget => {
      this.widgetIsLoaded = true;
      this.instance.loadMap(this.widgetInstance.widget, this.mapId);
    });

    this.instance.ready.subscribe(isReady => {
      this.mapEditor.init(this.map);
      this.loadObjects();
      this.zoomLevel = this.containerWidth / this.map.width;
      if (this.renderWhenReady) {
        this.render();
      }
    });
  }

  @HostListener('window:keydown', ['$event'])
  keyboardInput(event: KeyboardEvent) {
    if (event.key === '+') {
      this.instance.snapping = !this.instance.snapping;
    }
  }

  ngOnInit(): void {
    this.route.paramMap
      .subscribe((params: ParamMap) => {
        this.mapId = +params.get('mapId');
        this.instance.loadMap(this.widgetInstance.widget, this.mapId);
      })
  }

  saveSelectedRegion() {
    const objectId = this.regionEntityCtrl.value;
    const entity = this.getEntity(parseInt(objectId, 10));

    this.selectedRegion.entity = entity;
    this.mapService.updateRegion(this.selectedRegion)
      .subscribe(a => {

      });
  }

  onResize(dimensions: any) {
    this.containerWidth = dimensions.width - 50;
    this.containerHeight = dimensions.height - 50;

    if (this.autoSizeOn) {
      this.autoResize();
    }
  }


  ngOnChanges(): void {
  }

  toggleAutoSize() {
    this.autoSizeOn = !this.autoSizeOn;
    if (this.autoSizeOn) {
      this.autoResize();
    }
  }

  showSettings() {
    const modalRef = this.modal.open(CreateMapModalComponent);
    modalRef.componentInstance.init(this.widget, this.map);
    modalRef.result.then(map => {
      this.instance.reload();
    }).catch(() => {
    });
  }

  zoom(n?: number) {
    if (n === -1) {
      this.zoomLevel = Math.max(0.1, this.zoomLevel - 0.1);
    } else if (n === 1) {
      this.zoomLevel += .1;
    } else {
      this.zoomLevel = 1;
    }

    this.autoSizeOn = false;
  }

  ngAfterViewInit(): void {
    if (this.map) {
      this.render();
    } else {
      this.renderWhenReady = true;
    }
    //this.viewIsLoaded = true;

    /*let canvas = this.mainCanvas.nativeElement;
     this.context = canvas.getContext("2d");
     this.viewIsLoaded = true;*/

    /*if (this.map) {
     this.render();
     }*/
    /*

     if (this.map) {
     this.render();
     }*/
  }


  save() {
    this.isSaving = true;

    this.map.regions = this.map.regions.filter(r => {
      return r.entity;
    });

    this.mapService.updateRegions(this.map, this.map.regions)
      .finally(() => this.isSaving = false)
      .subscribe(map => {
        this.dirty = false;
      });
  }

  render() {
    console.log('[MapEditorComponent]: render');
    if (!this.svg) {
      this.svg = SVG.adopt(this.mainCanvas.nativeElement).size(this.width, this.height);
      this.svg.on('click', (e) => {
        this.mapEditor.triggerMouseClick(e);
      });
    }

    this.autoResize();
  }

  onObjectClick(region: WidgetMapRegion) {
    this.onSelected(region);
  }

  onObjectDraw(entity: RegionAttachable) {
    let newRegion = new WidgetMapRegion();
    newRegion.entity = entity;

    this.mapService.addRegion(this.map, newRegion).subscribe(region => {
      this.map.regions.push(region);
      this.onSelected(region);
    });

    //this.dirty = true;
  }

  onObjectUpdate(change: RegionAndEntity) {
    change.region.entity = change.entity;
    this.mapService.updateRegion(change.region)
      .subscribe(a => {

      });
  }

  onObjectDelete(region: WidgetMapRegion) {
    let idx = this.map.regions.findIndex((r) => {
      return r === region;
    });
    this.map.regions.splice(idx, 1);
    //this.buildRegions();
    this.selectedRegion = null;
    this.dirty = true;

    this.regionEntityCtrl.setValue(null);
  }

  deleteRegion() {
    let idx = this.map.regions.findIndex((r) => {
      return r === this.selectedRegion;
    });

    this.map.regions.splice(idx, 1);
    //this.buildRegions();
    this.selectedRegion = null;
    this.dirty = true;

    this.regionEntityCtrl.setValue(null);
  }

  get width() {
    return this.map ? this.map.width * this.zoomLevel : 0;
  }

  get height() {
    return this.map ? this.map.height * this.zoomLevel : 0;
  }

  get viewBox() {
    return `0 0 ${this.width * this.zoomLevel} ${this.height * this.zoomLevel}`;
  }


  onRegionChange(region: WidgetMapRegion) {
    this.dirty = true;
  }

  onSelected(region: WidgetMapRegion) {
    this.selectedRegion = region;

    let idx = this.map.regions.findIndex((r) => {
      return region == r;
    });

    // move to end of array so element is on top
    this.map.regions.splice(this.map.regions.length - 1, 0, this.map.regions.splice(idx, 1)[0]);

    this.regionEntityCtrl.setValue(region.entity ? region.entity.getId() : null);

  }


  selectRegion(region: WidgetMapRegion) {
    this.onSelected(region);
  }


  regionClass(region: WidgetMapRegion) {
    return 'r_g_' + region.id;
  }

  isRegionSelected(region: WidgetMapRegion) {
    return this.selectedRegion && this.selectedRegion.id === region.id;
  }

  get isObjectMap() {
    return this.map.type === WidgetMapType.Objects;
  }

  get isProjectMap() {
    return this.map.type === WidgetMapType.Projects;
  }

  get isMapMap() {
    return this.map.type === WidgetMapType.Maps;
  }

  get isSunstudy() {
    return this.map.sunstudy;
  }

  private throttledSave() {
    clearTimeout(this.saveTimer);
    this.saveTimer = setTimeout(() => {
      this.save();
    }, 2000);
  }

  private loadObjects() {
    if (this.map.type === WidgetMapType.Objects) {
      return this.objectService.get(this.widget.project).subscribe(objects => {
        this.projectObjects = objects;
      });
    }
  }

  private getEntity(id: number): RegionAttachable {
    if (this.isObjectMap) {
      return this.projectObjects.find(obj => {
        return obj.id === id;
      });
    } else if (this.isMapMap) {
      return this.widget.maps.find(obj => {
        return obj.id === id;
      });
    }
  }

  get widget() {
    return this.widgetInstance.widget;
  }

  autoResize() {
    if (this.map) {
      this.zoomLevel = this.containerWidth / this.map.width;
    }
  }

  set dirty(isDirty: boolean) {
    this._dirty = isDirty;
    if (this._dirty === true) {
      this.throttledSave();
    }
  }

  get dirty() {
    return this._dirty;
  }

  get map() {
    return this.instance.map;
  }
}



// WEBPACK FOOTER //
// ./src/app/widgets/widget-detail/map-editor/map-editor.component.ts